module.exports = __webpack_public_path__ + "static/media/emojiIcon.e1166409.svg";